var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"10.8cm !important"},attrs:{"id":'parent_element' + _vm.random_id}},[_c('div',{ref:"pdfViewer",staticStyle:{"width":"100%"},attrs:{"id":'preview_cont' + _vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }